export enum Seniority {
  /** Senior Secured */
  SeniorSecured = 'SD',
  /** Senior */
  Senior = 'SR',
  /** Subordinated */
  Subordinated = 'SB',
  Junior = 'JR',
  Mezzanine = 'MZ',
  SeniorNonPreferred = 'SN',
}
